import { useFormikContext } from 'formik';
import React, { useState, useRef, useEffect } from 'react';
import { hmdColors } from '../../models/select-hmd.model';

const HmdColorPicker = ({ defaultValue, onColorSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState(defaultValue || '00FFFF');
  const dropdownRef = useRef(null);
  const { errors, touched } = useFormikContext();

  // Find color name by hex code
  const getColorName = hexCode => {
    const color = hmdColors.find(c => c.hex === hexCode);
    return color ? color.name : '';
  };

  // Handle color selection
  const handleColorSelect = color => {
    setSelectedColor(color.hex);
    setIsOpen(false);

    if (onColorSelect) {
      onColorSelect({ hex: color.hex, name: color.name });
    }
  };

  // Handle clicks outside of dropdown to close it
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get currently selected color object
  const selectedColorObj =
    hmdColors.find(c => c.hex === selectedColor) || hmdColors[0];

  return (
    <div className="hmd-color-picker w-100" ref={dropdownRef}>
      <div
        className={`color-selector form-control ${
          errors?.color && touched?.color ? 'is-invalid' : ''
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className="color-box"
          style={{ backgroundColor: `#${selectedColor}` }}
        ></div>
        <div className="color-name">{getColorName(selectedColor)}</div>
        <div className="dropdown-arrow">{isOpen ? '▲' : '▼'}</div>
      </div>

      {isOpen && (
        <div className="color-dropdown">
          {hmdColors.map((color, index) => (
            <div
              key={index}
              className={`color-option ${
                selectedColor === color.hex ? 'selected' : ''
              }`}
              onClick={() => handleColorSelect(color)}
            >
              <div
                className="color-box"
                style={{ backgroundColor: `#${color.hex}` }}
              ></div>
              <div className="color-label">{color.name}</div>
            </div>
          ))}
        </div>
      )}

      <style jsx>{`
        .hmd-color-picker {
          position: relative;
          width: 250px;
        }

        .color-selector {
          display: flex;
          align-items: center;
          border: 1px solid #ccc;
          padding: 8px;
          cursor: pointer;
          height: 38px;
        }

        .color-box {
          width: 20px;
          height: 20px;
          border: 1px solid #ddd;
          margin-right: 10px;
        }

        .color-name {
          flex: 1;
        }

        .dropdown-arrow {
          padding: 0 8px;
          color: #666;
        }

        .color-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          max-height: 250px;
          overflow-y: auto;
          border: 1px solid #ccc;
          border-top: none;
          background: white;
          z-index: 100;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .color-option {
          display: flex;
          align-items: center;
          padding: 8px;
          cursor: pointer;
        }

        .color-option:hover {
          background-color: #f5f5f5;
        }

        .color-option.selected {
          background-color: #e6f7ff;
        }

        .color-label {
          margin-left: 10px;
        }
      `}</style>
    </div>
  );
};

export default HmdColorPicker;
